import { View } from 'react-native';

import { useMinimalCart } from 'hooks/use-minimal-cart';

import { CartDebugItem } from './cart-debug-item';

export const CartContentDebug = () => {
  const { cartEntries } = useMinimalCart();

  return (
    <View style={{ paddingVertical: 10 }}>
      {cartEntries.map(entry => (
        <CartDebugItem key={entry.cartId} cartEntry={entry} />
      ))}
    </View>
  );
};
